import { c as _c } from "react/compiler-runtime";
import type { Control } from 'react-hook-form';
import { useWatch } from 'react-hook-form';
export const NameLengthInfo = t0 => {
  const $ = _c(4);
  const {
    control
  } = t0;
  let t1;
  if ($[0] !== control) {
    t1 = {
      name: "name",
      control
    };
    $[0] = control;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const name = useWatch(t1);
  const t2 = `${name.length}/40 Zeichen`;
  let t3;
  if ($[2] !== t2) {
    t3 = <div className="mt-3 ml-3 font-body-small opacity-60">{t2}</div>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};